<template>
  <div>
    <div class="press-banner"></div>

    <div class="clearfix"></div>
    <div class="container-fluid">
      <div class="row full-press-cont">
        <main id="main" class="site-main main-content">
          <article
            id="post-2252"
            class="post-2252 page type-page status-publish hentry"
          >
            <div class="entry-content">
              <div class="hc-contact">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-2"></div>

                    <div class="col-sm-12 col-md-8 press-contact">
                      <h2 class="wow fadeIn">Press</h2>
                      <p class="text-center">
                        This form is available only for marketing and press-related communications. Please visit our ‘Contact Page’ for all other inquiries.
                      </p>
                      <div role="form" class="wpcf7" dir="ltr" lang="en-US">
                        <div class="screen-reader-response"></div>
                        <form
                          @submit.prevent="submitForm"
                          id="pressForm"
                          action="#"
                          method="post"
                          class="wpcf7-form"
                          novalidate
                        >
                          <div class="hostcluster-contact-none">
                            <input name="_wpcf7" value="2260" type="hidden" />
                            <input
                              name="_wpcf7_version"
                              value="5.0.3"
                              type="hidden"
                            />
                            <input
                              name="_wpcf7_locale"
                              value="en_US"
                              type="hidden"
                            />
                            <input
                              name="_wpcf7_unit_tag"
                              value="wpcf7-f2260-p2252-o1"
                              type="hidden"
                            />
                            <input
                              name="_wpcf7_container_post"
                              value="2252"
                              type="hidden"
                            />
                          </div>
                          <div class="hostcluster-contact row">
                            <div class="col-md-6">
                              <label
                                >First Name<span
                                  class="wpcf7-form-control-wrap first-name"
                                  ><input
                                    name="pressFirstName"
                                    size="40"
                                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                    aria-required="true"
                                    aria-invalid="false"
                                    v-model="pressFirstName"
                                    type="text" /></span
                              ></label>
                            </div>
                            <div class="col-md-6">
                              <label
                                >Last Name<span
                                  class="wpcf7-form-control-wrap last-name"
                                  ><input
                                    name="pressLastName"
                                    size="40"
                                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                    aria-required="true"
                                    aria-invalid="false"
                                    v-model="pressLastName"
                                    type="text" /></span
                              ></label>
                            </div>
                            <div class="col-md-6">
                              <label
                                >Your E-mail<span
                                  class="wpcf7-form-control-wrap email"
                                  ><input
                                    name="pressEmail"
                                    size="40"
                                    class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email"
                                    aria-required="true"
                                    aria-invalid="false"
                                    type="email"
                                    v-model="pressEmail" /></span
                              ></label>
                            </div>
                            <div class="col-md-6">
                              <label
                                >Phone<span
                                  class="wpcf7-form-control-wrap email"
                                  ><input
                                    name="pressPhone"
                                    size="40"
                                    class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-phone"
                                    aria-required="true"
                                    aria-invalid="false"
                                    v-model="pressPhone"
                                    type="number" /></span
                              ></label>
                            </div>

                            <div class="col-md-12">
                              <label
                                >Media Publication<span
                                  class="wpcf7-form-control-wrap first-name"
                                  ><input
                                    name="pressMedia"
                                    size="40"
                                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                    aria-required="true"
                                    aria-invalid="false"
                                    v-model="pressMedia"
                                    type="text" /></span
                              ></label>
                            </div>
                            <div class="col-md-12">
                              <label
                                >Your Message<span
                                  class="wpcf7-form-control-wrap first-name"
                                  ><input
                                    name="pressIssue"
                                    size="40"
                                    class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                    aria-required="true"
                                    aria-invalid="false"
                                    v-model="pressIssue"
                                    type="text" /></span
                              ></label>
                            </div>

                            <div class="col-md-12 text-center" v-if="recaptchaToken === null" style="margin-bottom: 50px">
                              <vue-recaptcha
                                ref="recaptcha"
                                @verify="onCaptchaVerified"
                                @expired="onCaptchaExpired"
                                sitekey="6LektFYaAAAAAFLNPWH6-haAoVbtIeZ5xuBE5sJc"
                              ></vue-recaptcha>
                          </div>

                            <div class="col-md-12 text-center">
                              <p
                                class="form-error"
                                v-if="pressFormSuccess"
                                style="color: green; font-size: 1em; font-weight: bold;background: #aee0ae;padding: 10px;border-radius: 5px;"
                              >
                                Message Sent.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                  background: #ffb6b6;
                                  padding: 10px;
                                  border-radius: 5px;
                                "
                              >
                                Please fill form.
                              </p>
                              <p
                                class="form-error"
                                v-if="submitError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                  background: #ffb6b6;
                                  padding: 10px;
                                  border-radius: 5px;
                                "
                              >
                                Something went wrong. Please try again.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormFirstNameError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                "
                              >
                                First name is required.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormLastNameError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                "
                              >
                                Last name is required.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormEmailError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                "
                              >
                                Email is required.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormPhoneError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                "
                              >
                                Phone is required.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormMediaError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                "
                              >
                                Media publication is required.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormMessageError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                "
                              >
                                Your message is required.
                              </p>
                              <p
                                class="form-error"
                                v-if="pressFormEmailFormatError"
                                style="
                                  color: #ff9999;
                                  font-size: 1em;
                                  font-weight: bold;
                                "
                              >
                                Invalid email format. Please enter valid email
                                address.
                              </p>
                            </div>

                            <div class="col-md-12 text-center">
                              <input
                                v-if="recaptchaToken !== null"
                                value="Send Message"
                                class="wpcf7-form-control wpcf7-submit"
                                type="submit"
                              /><span class="ajax-loader"></span>
                            </div>
                          </div>
                          <div
                            class="wpcf7-response-output wpcf7-display-none"
                          ></div>
                        </form>
                      </div>
                    </div>

                    <div class="col-md-2"></div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- .entry-content -->
          </article>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "press",
  components: {
    'vue-recaptcha': VueRecaptcha
  },
  data() {
    return {
      msg: "Clear Me Out - Press",
      pressFirstName: "",
      pressLastName: "",
      pressEmail: "",
      pressMedia: "",
      pressPhone: "",
      pressIssue: "",
      pressFormError: false,
      pressFormEmailError: false,
      pressFormFirstNameError: false,
      pressFormLastNameError: false,
      pressFormPhoneError: false,
      pressFormMediaError: false,
      pressFormMessageError: false,
      pressFormEmailFormatError: false,
      pressFormSuccess: false,
      submitError: false,
      recaptchaToken: null,
    };
  },
  methods: {
    onCaptchaVerified: function(recaptchaToken) {
      const $this = this;

      $this.recaptchaToken = recaptchaToken;
    },
    onCaptchaExpired: function () {
      const $this = this;
      $this.$refs.recaptcha.reset();
      $this.recaptchaToken = null;
    },
    submitForm: function () {
      const $this = this;

      this.pressFormError = false;
      this.pressFormFirstNameError = false;
      this.pressFormLastNameError = false;
      this.pressFormPhoneError = false;
      this.pressFormMediaError = false;
      this.pressFormMessageError = false;
      this.pressFormEmailError = false;
      this.pressFormSuccess = false;
      this.pressFormEmailFormatError = false;
      this.submitError = false;

      if (
        this.pressFirstName === "" &&
        this.pressLastName === "" &&
        this.pressEmail === "" &&
        this.pressMedia === "" &&
        this.pressPhone === "" &&
        this.pressIssue === ""
      ) {
        $this.pressFormError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }

      if (this.pressFirstName === "") {
        $this.pressFormFirstNameError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.pressLastName === "") {
        $this.pressFormLastNameError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.pressEmail === "") {
        $this.pressFormEmailError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(String(this.pressEmail).toLowerCase())) {
        $this.pressFormEmailFormatError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.pressPhone === "") {
        $this.pressFormPhoneError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.pressMedia === "") {
        $this.pressFormMediaError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }
      if (this.pressIssue === "") {
        $this.pressFormMessageError = true;

        $this.recaptchaToken = null;

        setTimeout(() => {
          $this.$refs.recaptcha.reset()
        }, 100);
        return;
      }

      $this.contactUsFormError = false;
      $this.pressFormEmailError = false;

      emailjs
        .sendForm("service_cq4h4ph", "template_ieocprr", "#pressForm")
        .then(
          function (response) {
            $this.pressFormSuccess = true;

            $this.recaptchaToken = null;

            setTimeout(() => {
              $this.$refs.recaptcha.reset()
            }, 100);
          },
          function (error) {
            $this.submitError = true;
            $this.recaptchaToken = null;

            setTimeout(() => {
              $this.$refs.recaptcha.reset()
            }, 100);
          }
        );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/press.vue